module.exports = __webpack_public_path__ + "img/microphone-01.83adb6f0.svg";